import Flag from "react-world-flags";

// Project components
import countries from "../../data/country-flag.json";

function getFlagEmoji(countryCode) {
  if (countryCode == null) return null;
  const codePoints = [...countryCode.toUpperCase()].map(
    (char) => 127397 + char.charCodeAt()
  );
  return String.fromCodePoint(...codePoints);
}

function Country({ code }) {
  const country = countries.find((c) => c.code === code.toLowerCase());
  //const url = `https://www.google.com/maps?q=${country.latitude},${country.longitude}`

  const containerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  };

  const imageStyle = {
    height: "24px",
    objectFit: "contain",
  };

  return (
    <div style={containerStyle}>
      <Flag code={code} style={{ width: "24px" }} />
      <span>
        {country?.name ?? `Found no name for this country code ${code}`}
      </span>
    </div>
  );
}

export default Country;
export { countries };
